<!-- xuqing 权限复制 2021-3-29 14:29:14 -->
<template>
    <td-dialog
        :title="$t('userInfo.COPY_AUTHORITY')"
        :visible.sync="dialogVisible"
        append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        :before-close="dialogClose"
        :width="this.modifyDialogWidth + 'px'"
    >
        <el-form :model="copyAuthorityInfo" ref="copyAuthorityInfoForm">
            <el-row>
                <el-form-item :label="$t('role.CURRENT_USER_ROLE')" :label-width="labelWidth + 'px'" class="el-input__inner" style="padding-top:0px">
                    <el-popover trigger="hover" placement="top-start" :content="roleNames" width="300">
                        <div slot="reference" style="overflow: hidden;width: 80%;text-overflow: ellipsis;white-space: nowrap;">
                            <span>{{ roleNames }}</span>
                        </div>
                    </el-popover>
                </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('userInfo.NAME')" :label-width="formLabelWidth + 'px'" prop="userName">
                        <td-input v-model="copyAuthorityInfo.staffName"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('userInfo.ORG_GROUP')" :label-width="formLabelWidth + 'px'">
                        <td-tree-select
                            ref="orgTreeSelect"
                            v-model="checkedNodes"
                            :lazyloading="true"
                            nodeKey="id"
                            :isDbClick="true"
                            :isClick="true"
                            :imgloading="true"
                            :inputShow="true"
                            :showBox="true"
                            :defaultProps="defaultProps"
                            :params="orgTreeSelectParams"
                            :calInternal="true"
                            :isPaging="true"
                            :interfaceName="interfaceName"
                            :checkStrictly="false"
                        ></td-tree-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                        <td-button :loading="queryLoading" @click="btnQuery">{{ $t('common.QUERY') }}</td-button>
                        <td-button @click="btnChecked">{{ clearAllRoleButtonTitle }}</td-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <td-table
            :columns="columns"
            :dataSource="tableData"
            :pageSize="pageSize"
            :currentPage="currentPage"
            :total="total"
            :hasLoading="queryLoading"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
            @handleSelectAll="handleSelectAll"
            @handleSelect="handleSelect"
            rowKey="staffId"
            ref="userTable"
            height="400px"
        ></td-table>
        <template slot="footer">
            <el-row>
                <el-col>
                    <td-button type="primary" :loading="confirmLoading" @click="btnConfirm">{{ $t('common.SAVE') }}</td-button>
                    <td-button @click="dialogClose">{{ $t('common.CLOSE') }}</td-button>
                </el-col>
            </el-row>
        </template>
    </td-dialog>
</template>

<script>
import resourceApi from '../assets/api.js';
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        sysFlg: {
            type: String,
            default: function() {
                return window.authCommon.defaultSysFlag;
            }
        },
        editItem: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.modifyDialogWidth = 880 + (Number(newVal) == 14 ? 0 : 8 * Number(newVal));
                this.formLabelWidth = 68 + (Number(newVal) == 14 ? 0 : 2 * Number(newVal));
                this.labelWidth = 100 + (Number(newVal) == 14 ? 0 : 2 * Number(newVal));
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    //创建完成 访问当前this实例
    created() {
        this.initUserRole();
    },
    //挂载完成 访问DOM元素
    mounted() {
        this.queryStaffInfo();
    },
    data() {
        return {
            labelWidth: 100,
            formLabelWidth: 68,
            roleNames: '',
            roleIds: [],
            copyAuthorityInfo: {
                staffName: '',
                structureIdList: []
            },
            checkedNodes: [],
            columns: [
                {
                    prop: 'staffName',
                    label: this.$t('userInfo.NAME'),
                    tableWidth: '280'
                },
                {
                    prop: 'structureName',
                    label: this.$t('role.ORG_STRUCTURE'),
                    tableWidth: '280'
                },
                {
                    prop: 'isAuthRetain',
                    align: 'center',
                    tableWidth: '203',
                    label: this.$t('role.IS_CLEAR_ROLE'),
                    render: (createElement, params) => {
                        let checkboxAttr = {
                            props: { type: 'text', size: 'small', value: params.row.isAuthRetain, activeText: '', inactiveText: '' },
                            on: {
                                change: checked => {
                                    params.row.isAuthRetain = checked;
                                    let checkAllStatus = false;
                                    let checkedDataCount = 0;
                                    let clearRoleCount = 0;
                                    for (let i = 0; i < this.tableData.length; i++) {
                                        if (this.tableData[i].isAuthRetain) {
                                            clearRoleCount++;
                                        }
                                        if (this.tableData[i].isCheckedData) {
                                            checkedDataCount++;
                                        }
                                    }
                                    if (checkedDataCount == clearRoleCount) {
                                        checkAllStatus = true;
                                    }
                                    this.clearAllRoleButtonTitle = checkAllStatus ? this.$t('role.CLEAR_ALL_ROLE') : this.$t('role.CANCEL_CLEAR_ALL_ROLE');
                                    this.clearAuth = checkAllStatus;
                                    console.info('this.clearAuth -> ', this.clearAuth, ' checkedDataCount -> ', checkedDataCount, '  clearRoleCount -> ', clearRoleCount);
                                }
                            }
                        };
                        if (params.row.isCheckedData) {
                            checkboxAttr.props.disabled = false;
                        } else {
                            checkboxAttr.props.disabled = true;
                            params.row.isAuthRetain = false;
                        }
                        let checkbox = createElement('td-switch', checkboxAttr);

                        return createElement('div', [checkbox]);
                    }
                }
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 30,
            total: 0,
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            interfaceName: {
                query: '/OrgStructureController/findOrgStructureTree',
                search: '/OrgStructureController/findOrgStructureTree'
            },
            orgTreeSelectParams: {
                pageSize: 50,
                currentPage: 1,
                needPage: true
            },
            confirmLoading: false,
            commitCount: 1,
            queryLoading: false,
            clearAuth: false,
            clearAllRoleButtonTitle: this.$t('role.CLEAR_ALL_ROLE')
        };
    },

    //方法集合
    methods: {
        dialogClose() {
            this.$emit('dialogClose');
        },
        btnQuery() {
            this.copyAuthorityInfo.structureIdList = [];
            if (this.$util.isArray(this.checkedNodes)) {
                for (let i = 0; i < this.checkedNodes.length; i++) {
                    let orgId = this.checkedNodes[i].orgId;
                    if (!this.$util.isEmpty(orgId)) {
                        this.copyAuthorityInfo.structureIdList.push(orgId);
                    }
                }
            }
            this.currentPage = 1;
            this.queryStaffInfo();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryStaffInfo();
        },
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryStaffInfo();
        },
        queryStaffInfo() {
            this.queryLoading = true;
            this.copyAuthorityInfo.needPage = true;
            this.copyAuthorityInfo.currentPage = this.currentPage;
            this.copyAuthorityInfo.pageSize = this.pageSize;
            this.copyAuthorityInfo.recursiveQuery = true;
            this.copyAuthorityInfo.isStaffDistinct = false;
            resourceApi.getAllStaffInfo(JSON.stringify(this.copyAuthorityInfo), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getAllStaffInfo', response.data.statusMessage);
                    this.queryLoading = false;
                    return;
                }
                let content = response.data.content;
                for (let i = 0; i < content.length; i++) {
                    content[i].isAuthRetain = false;
                    content[i].isCheckedData = false;
                }
                this.tableData = content;
                this.total = response.data.count;
                this.queryLoading = false;
            });
        },
        // 初始化用户角色
        initUserRole() {
            let paramOrgInfo = {
                sId: this.editItem.id,
                sysFlg: this.sysFlg,
                orgFlg: window.authCommon.roleType.orgRole
            };

            resourceApi.getUserRole(JSON.stringify(paramOrgInfo), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRole', response.data.statusMessage);
                    return;
                }
                let userOrgRoles = response.data.content;
                if (this.$util.isArray(userOrgRoles)) {
                    let orgNames = [];
                    for (let index = 0; index < userOrgRoles.length; index++) {
                        orgNames.push(userOrgRoles[index].sName);
                        this.roleIds.push(userOrgRoles[index].sId);
                    }
                    if (!this.$util.isEmpty(this.roleNames)) {
                        this.roleNames += ', ';
                    }
                    this.roleNames += orgNames.join(', ');
                }
                this.initRoleCheckState();
            });
        },
        // 初始化用户自定义角色
        initRoleCheckState() {
            let userId = this.editItem.id;
            let formData = new FormData();
            formData.append('userId', userId);
            resourceApi.getCheckedRole(formData, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getCheckedRole', formData, response.data.statusMessage);
                    return;
                }
                let checkedRoleList = response.data.content;
                if (!this.$util.isArray(checkedRoleList)) {
                    return;
                }
                let customRoleNames = [];
                for (let j = 0; j < checkedRoleList.length; j++) {
                    customRoleNames.push(checkedRoleList[j].roleName);
                    this.roleIds.push(checkedRoleList[j].id);
                }
                if (!this.$util.isEmpty(this.roleNames)) {
                    this.roleNames += ', ';
                }
                this.roleNames += customRoleNames.join(', ');
                if (this.$util.isEmpty(this.roleNames)) {
                    this.roleNames = this.$t('role.NONE');
                }
            });
        },
        btnConfirm() {
            this.confirmLoading = true;
            this.commitCount = 1;
            let selectData = this.$refs.userTable.getSelectAllRows();
            if (selectData.length < 1) {
                this.$message({ showClose: true, message: this.$t('userInfo.PLEASE_SELECT_USER'), type: 'warning' });
                this.confirmLoading = false;
                return;
            }
            if (this.roleIds.length < 1) {
                this.$message.warning({ showClose: true, message: this.$t('role.CURRENT_USER_NOT_CONFIG_AUTHORITY') });
                this.confirmLoading = false;
                return;
            }
            let userIds = [];
            let clearUserIds = [];
            for (let i = 0; i < selectData.length; i++) {
                if (selectData[i].isAuthRetain) {
                    userIds.push(selectData[i].staffId);
                } else {
                    clearUserIds.push(selectData[i].staffId);
                }
            }
            if (userIds.length > 0 && clearUserIds.length > 0) {
                this.commitCount = 2;
            }
            if (userIds.length > 0) {
                this.batchAddUserRoles(userIds);
            }
            if (clearUserIds.length > 0) {
                this.batchCoverUserRoles(clearUserIds);
            }
        },
        // 批量给用户添加角色
        batchAddUserRoles(userIds) {
            let addUserRoles = {
                userIds: userIds,
                roleIds: this.roleIds
            };
            resourceApi.batchAddUserRoles(addUserRoles, response => {
                this.commitCount -= 1;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auth/user/batchAddUserRoles', response.data.statusMessage);
                    if (this.commitCount < 1) {
                        this.confirmLoading = false;
                    }
                    return;
                }
                if (this.commitCount < 1) {
                    this.confirmLoading = false;
                    this.$message({ showClose: true, message: this.$t('common.SAVE_SUCCESS'), type: 'success' });
                    this.dialogClose();
                }
            });
        },
        // 批量给用户覆盖角色
        batchCoverUserRoles(userIds) {
            let deleteUserRoles = {
                userIds: userIds
            };
            resourceApi.batchDeleteUserRoles(deleteUserRoles, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auth/user/batchDeleteUserRoles', response.data.statusMessage);
                    this.confirmLoading = false;
                    return;
                }
                this.batchAddUserRoles(userIds);
            });
        },
        handleSelectAll(selection) {
            if (!this.$util.isArray(selection)) {
                return;
            }
            for (let i = 0; i < this.tableData.length; i++) {
                if (selection.length < 1) {
                    this.tableData[i].isCheckedData = false;
                } else {
                    this.tableData[i].isCheckedData = true;
                    this.tableData[i].isAuthRetain = true;
                }
            }
            this.clearAuth = true;
            this.clearAllRoleButtonTitle = this.$t('role.CLEAR_ALL_ROLE');
        },
        handleSelect(selectedData) {
            if (!this.$util.isArray(selectedData)) {
                return;
            }
            let authRetainCount = 0;
            for (let i = 0; i < this.tableData.length; i++) {
                let selected = false;
                for (let j = 0; j < selectedData.length; j++) {
                    if (selectedData[j].staffId == this.tableData[i].staffId) {
                        selected = true;
                        authRetainCount++;
                        break;
                    }
                }
                this.tableData[i].isCheckedData = selected;
                this.tableData[i].isAuthRetain = selected;
            }
            if (selectedData.length == authRetainCount) {
                this.clearAuth = true;
                this.clearAllRoleButtonTitle = this.$t('role.CLEAR_ALL_ROLE');
            } else {
                this.clearAuth = false;
                this.clearAllRoleButtonTitle = this.$t('role.CANCEL_CLEAR_ALL_ROLE');
            }
        },
        btnChecked() {
            let selectData = this.$refs.userTable.getSelectAllRows();
            if (selectData.length < 1) {
                this.$message({ showClose: true, message: this.$t('userInfo.PLEASE_SELECT_USER'), type: 'warning' });
                return;
            }

            if (this.clearAuth) {
                this.$confirm(this.$t('role.IS_CLEAR_USER_ALL_ROLE'), this.$t('common.TIPS'), {
                    confirmButtonText: this.$t('common.SURE'),
                    cancelButtonText: this.$t('common.CANCEL'),
                    type: 'warning'
                })
                    .then(() => {
                        this.clearAuth = false;
                        for (let i = 0; i < this.tableData.length; i++) {
                            if (this.tableData[i].isCheckedData) {
                                this.tableData[i].isAuthRetain = this.clearAuth;
                            }
                        }
                        this.clearAllRoleButtonTitle = this.$t('role.CANCEL_CLEAR_ALL_ROLE');
                    })
                    .catch(() => {});
            } else {
                this.clearAuth = true;
                for (let i = 0; i < this.tableData.length; i++) {
                    if (this.tableData[i].isCheckedData) {
                        this.tableData[i].isAuthRetain = this.clearAuth;
                    }
                }
                this.clearAllRoleButtonTitle = this.$t('role.CLEAR_ALL_ROLE');
            }
        }
    }
};
</script>
<style scoped></style>
